import { render } from "./OrderPayment.vue?vue&type=template&id=13d88740&ts=true"
import script from "./OrderPayment.vue?vue&type=script&lang=ts"
export * from "./OrderPayment.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__